/* FERRY AUTO-GENERATED: DO NOT EDIT THIS FILE */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

export enum ShopLevel {
  Low_Level_Shop = 1,
  Mid_Level_Shop = 2,
  High_Level_Shop = 3,
  Shop_Level_4 = 4,
  Shop_Level_5 = 5,
  Shop_Level_6 = 6,
  Shop_Level_7 = 7,
  Shop_Level_8 = 8,
  Shop_Level_9 = 9,
}

export enum GmvLevel {
  GMV_0_Level = 0,
  GMV_0_2000_Level = 1,
  GMV_2000_50000_Level = 2,
  GMV_50000_Over_Level = 3,
}

export enum QuotaType {
  Week = 1,
  Period = 2,
  Bonus = 3,
}

export enum CanNotConnectType {
  SELLER_BLOCK = 1,
  CREATOR_BLOCK = 2,
  FAN_THRESHOLD = 3,
}

export interface ShopConnection {
  new_connect_count?: number;
  pair_connect_count?: number;
}

export interface RuleBasic {
  /** 过去一周的商家gmv */
  shop_week_gmv?: GMVValue;
  /** 店铺等级 */
  shop_level?: ShopLevel;
  /** 店铺GMV分级规则 */
  gmv_level_rule?: Array<GMVLevelRule>;
  /** 下一次限制规则刷新时间, e.g "2024-05-05" */
  next_refresh_day?: string;
  /** 下次更新刷新时间, 小时 */
  next_refresh_hour?: string;
  /** 下次更新刷新时区, utc-8返回"UTC-8",utc+0返回"UTC+0" */
  next_refresh_offset?: string;
  /** 此地区是否存在粉丝数限制 */
  region_has_follower_limit?: boolean;
  /** 商户GMV等级 */
  quota_gmv_level?: GmvLevel;
  /** 周期内gmv */
  period_gmv?: GMVValue;
}

export interface LimitRule {
  /** 可以触达的粉丝数上限, -1表示无限制 */
  reached_max_follower_cnt?: string;
}

export interface GMVLevelRule {
  shop_level?: ShopLevel;
  /** gmv范围左区间, 闭, 如果只返回了左区间, 表示没有右区间限制 */
  left_gmv?: GMVValue;
  /** gmv范围右区间, 开 */
  right_gmv?: GMVValue;
  /** 当前等级商家可以触达达人的粉丝数上限 */
  reached_max_follower_cnt?: string;
  /** 一周内可以创建会话的最大数量 */
  max_create_conversation_week_quota?: string;
  /** 对应的GMV level，IM/邀约使用该枚举 */
  gmv_level?: GmvLevel;
}

export interface GMVValue {
  /** 货币单位 */
  currency?: string;
  /** 货币值 */
  amount?: string;
  /** 格式化的值 */
  format_value?: string;
}

export interface Quota {
  quota_type: QuotaType;
  /** 最大上限，-1表示没有限制 */
  max_quota?: string;
  /** 目前已使用数 */
  used_num?: string;
}

export interface CreatorConnect {
  creator_id?: string;
  is_connect?: boolean;
  is_pair_connect?: boolean;
  has_sent_im?: boolean;
  has_sent_target_invitation?: boolean;
  can_not_connect_type?: Array<CanNotConnectType>;
}
